import { BusinessDomainEntity } from '../entities';
import { QueryBusinessUnitPayload } from '../ports/payloads';
import { BusinessUnitRepository } from '../ports/repositories/business-unit.repository';

export class GetListBusinessDomainUsecase {
  constructor(private readonly repo: BusinessUnitRepository) {}

  async run(payload?: QueryBusinessUnitPayload): Promise<BusinessDomainEntity[]> {
    const data = await this.repo.getListBusinessDomain(payload);
    return data;
  }
}
